import React from "react";

function DownArrow() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="8"
            fill="none"
            viewBox="0 0 16 8"
        >
            <path
                fill="#58616D"
                fillRule="evenodd"
                d="M.487 1.393L2.074 0l5.94 5.214L13.952 0l1.587 1.393L8.013 8 .487 1.393z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default DownArrow;
